/**
 * Mirrors Core\Response (backend/src/Core/Response.php) exactly —
 * every endpoint returns this envelope.
 */
export interface ApiSuccess<T> {
  success: true;
  message: string;
  data: T;
  meta: PaginationMeta | null;
  error: null;
}

export interface ApiError {
  success: false;
  message: string;
  data: null;
  meta: null;
  error: {
    code: string;
    details: Record<string, string[]> | Record<string, unknown> | null;
  };
}

export type ApiEnvelope<T> = ApiSuccess<T> | ApiError;

export interface PaginationMeta {
  page: number;
  per_page: number;
  total: number;
  total_pages: number;
  has_next: boolean;
  has_previous: boolean;
}

export interface PaginatedResult<T> {
  items: T[];
  meta: PaginationMeta;
}

/** Query params accepted by every paginated list endpoint. */
export interface ListQueryParams {
  page?: number;
  per_page?: number;
  search?: string;
  sort?: string;
  order?: 'asc' | 'desc';
  filter?: Record<string, string | number | boolean | undefined>;
}

export class ApiClientError extends Error {
  constructor(
    message: string,
    public readonly code: string,
    public readonly status: number,
    public readonly details: Record<string, string[]> | Record<string, unknown> | null,
  ) {
    super(message);
    this.name = 'ApiClientError';
  }

  /** Field-level validation errors, if this was a 422. */
  get fieldErrors(): Record<string, string[]> | null {
    if (this.code !== 'VALIDATION_ERROR' || !this.details) return null;
    return this.details as Record<string, string[]>;
  }
}
